import { ChangeDetectionStrategy, Component, inject, input, OnInit } from '@angular/core';
import { ReactiveFormsModule, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { NODE_EDIT_TAB_COMPONENT, NodeEditTab, SelectedNodeForEdit } from 'src/app/shared/flow-chart/flow-chart.model';
import { ResizeNodeData } from '../../../node-edit.type';

@Component({
  selector: 'edit-resize',
  imports: [
    ReactiveFormsModule,
    TranslatePipe,
  ],
  templateUrl: './edit-resize.component.html',
  styleUrl: './edit-resize.component.scss',
  providers: [
    {
      provide: NODE_EDIT_TAB_COMPONENT,
      useExisting: EditResizeComponent,
    },
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EditResizeComponent implements OnInit, NodeEditTab {
  public selectedNodeForEdit = input<SelectedNodeForEdit<ResizeNodeData>>();
  public disableForm = input<boolean>(false);

  private readonly fb = inject(UntypedFormBuilder);
  private readonly translateService = inject(TranslateService);

  public form: UntypedFormGroup = this.fb.group({
    name: [this.translateService.instant('FLOW_CHART.NODES.RESIZE.NAME'), [Validators.required]],
    factor: [null, [Validators.required]],
    maxW: [null, [Validators.required]],
  })

  public ngOnInit(): void {
    if (this.disableForm()) {
      this.form.disable();
    }

    if (this.selectedNodeForEdit()?.data?.name) {
      this.form.setValue({
        name: this.selectedNodeForEdit().data.name,
        factor: this.selectedNodeForEdit().data.factor,
        maxW: this.selectedNodeForEdit().data.maxW,
      })
    }
  }
}
